import { AppMessageConfigProps, AppMessageControlsApi } from '@/common/components/AppMessage/AppMessage';

import { QueryError } from '@/common/interfaces';

export const messageOnError = (
  error: QueryError,
  appMessageApi: AppMessageControlsApi,
  configOverride?: AppMessageConfigProps
) => {
  const errorData = error.response?.data;

  if (errorData) {
    const message = Array.isArray(errorData.message)
      ? errorData.message[0]?.errors?.[0]
      : errorData.message;

    if (message) appMessageApi.error(message, { key: error?.config?.url ?? crypto.randomUUID(), ...configOverride });
  } else {
    appMessageApi.error(error.message, { key: error?.config?.url ?? crypto.randomUUID(), ...configOverride });
  }
};
